<div class="card card-statistics mb-30" [hidden]="Data_Seleted_Customer.id>0">
  <div class="card-body">
    <div class="float-left">
      <h5 class="card-title">
        انتخاب حکم ماموریت جهت ثبت اطلاعات کالیبراسیون
        <span *ngIf="Procssing_LetterRequestCustomer">(در حال دریافت اطلاعات ...)</span>
      </h5>
    </div>
    <div class="float-right">
      <select class="custom-select" (change)="ReadData_LetterRequestCustomer()"
        [(ngModel)]="Show_Draft_LetterRequestCustomer" name="Show_Draft_LetterRequestCustomer">
        <option value="0">نامه های فعال</option>
        <option value="1">نامه های بایگانی</option>
      </select>
    </div>

    <div style="clear: both;"></div>

    <button (click)="OnSet_Back_CalibrationList(0)" type="button" class="btn btn-warning"><i
        class="fa fa-mail-reply"></i> بازگشت </button>

    <br />
    <br />

    <div class="row">
      <div class="form-group col-md-6">
        <label for="exampleInputEmail1">نام مشتری</label>
        <input [(ngModel)]="Filter_CustomerName" name="Filter_CustomerName" type="text" class="form-control"
          placeholder="برای جستجوی ، اینجا تایپ کنید ...">
      </div>

      <div class="form-group col-md-6">
        <label for="exampleInputEmail1"> شماره نامه </label>
        <input [(ngModel)]="Filter_LetterCode" name="Filter_LetterCode" type="text" class="form-control"
          placeholder="برای جستجوی ، اینجا تایپ کنید ...">
      </div>

    </div>

    <div class="row">

      <div class="col-md-4 mb-30" *ngFor="let item of DataList_LetterRequestCustomer
            |filter:Filter_CustomerName:'customer'
            |filter:Filter_LetterCode2:'code2'
            |filter:Filter_LetterCode:'code'
            | paginate
                    : {
                        id: 'DataList_LetterRequestCustomer',
                        itemsPerPage: 15,
                        currentPage: page_MainList,
                        totalItems: (DataList_LetterRequestCustomer
                        |filter:Filter_CustomerName:'customer'
                        |filter:Filter_LetterCode2:'code2'
                        |filter:Filter_LetterCode:'code'
                        ).length
                      }">

        <div class="card h-100">
          <div class="card-body">

            <h6 class="card-title"> نامه شماره '{{item.code}}' </h6>
            <h6> {{item.customer}} </h6>
            <p> دستگاه/های درخواست شده : {{item.deviceCount[0]}} عدد </p>
            <p> کالیبره نشده : {{item.deviceCount[1]}} عدد </p>
            <hr>
            <p> تاریخ (ها) حکم : {{item.schedule_single}}</p>
            <hr>

            <button (click)="Set_Selected_LetterRequestCustomer(item)" type="button" class="btn btn-info"
              style="margin-left: 5px;"><i class="fa fa-plus-circle"></i> ثبت رسید </button>

            <button (click)="ChangeDraftClibrationReception(item)" *ngIf="Show_Draft_LetterRequestCustomer=='0'"
              type="button" class="btn btn-warning"><i class="fa fa-save"></i> بایگانی </button>

            <button (click)="ChangeDraftClibrationReception(item)"
              *ngIf="Show_Draft_LetterRequestCustomer=='1' && item.deviceCount[1]>0" type="button"
              class="btn btn-danger"><i class="fa  fa-undo"></i> فعال سازی </button>

            <br />

            <button style="display: block;margin: auto;margin-top: 10px;"
              (click)="openModal_LetterCustomer_Cancel(templateLetterRequestCustomerCancel,item)"
              *ngIf="item.deviceCount[0] == item.deviceCount[1] && item.peyvaset && !item.bazgasht" type="button"
              class="btn btn-danger"><i class="fa  fa-warning"></i> درخواست لغو ماموریت </button>


          </div>
        </div>
      </div>

      <div style="clear: both;"></div>

      <pagination-controls id="DataList_LetterRequestCustomer" nextLabel="بعدی" previousLabel="قبلی"
        (pageChange)="page_MainList = $event"></pagination-controls>
    </div>






  </div>
</div>

<div class="card card-statistics mb-30" *ngIf="Data_Seleted_Customer.id>0">
  <div class="card-body">
    <h5 class="card-title">فرم ثبت اطلاعات کالیبراسیون در محل مشتری</h5>

    <div>
      <form>
        <br />
        <br />
        <div class="row">
          <div class="form-group col-md-2">
            <label for="exampleInputEmail1"> شماره نامه </label>
            <input type="text" class="form-control" disabled value="{{Selected_DataList_LetterRequestCustomer.code}}" />
          </div>
          <div class="form-group col-md-2">
            <label for="exampleInputEmail1"> شماره رسید </label>
            <input type="text" class="form-control" disabled value="{{Calibration_Form_Code}}" />
          </div>

          <div class="form-group col-md-8">
            <label for="exampleInputEmail1">نام مشتری </label>
            <input style="font-weight: bolder;" type="text" class="form-control" disabled
              value="{{Data_Seleted_Customer.name}}" />
          </div>
        </div>
      </form>
      <br />
      <hr />
      <br />

      <app-CutomerKarshnas [inner_Customer]="Data_Seleted_Customer.id">
      </app-CutomerKarshnas>

      <br />
      <hr />
      <br />

      <h5> دستگاه </h5>

      <form>
        <br />
        <br />
        <div class="row">
          <div class="form-group col-md-6">
            <label for="exampleInputEmail1"><button type="button" (click)="openModal_Device(templateDevice)"
                class="btn btn-danger left"> انتخاب دستگاه <i class="fa  fa-simplybuilt"></i> </button> </label>

          </div>
        </div>

      </form>

      <br />
      <br />

      <div class="table-responsive" *ngIf="Data_List_Calibration.length>0">
        <table class="mb-0 table table-bordered table-3 text-center table-striped">
          <thead style="background-color: #489b39; color: white;">
            <tr>
              <th>#</th>
              <th>نام دستگاه</th>
              <th>کد دستگاه</th>
              <th>سریال دستگاه</th>
              <th>توضیحات</th>
              <th>وضیعت</th>
              <th>درصد تخفیف</th>
              <th>تاریخ ثبت</th>
              <th *ngIf="!OnSubmitForm_Finish">تجهیز بهفا</th>
              <th>امکانات</th>
            </tr>
          </thead>
          <tbody>

            <ng-container *ngFor="let item of Data_List_Calibration">
              <tr>
                <td>{{Data_List_Calibration.indexOf(item)+1}}</td>
                <td class="EnglishClm">{{item.device_name}}</td>
                <td>
                  <p class="EnglishClm" *ngIf="OnSubmitForm_Finish && item.status!=2">{{item.device_code}}</p>
                  <p class="EnglishClm" *ngIf="item.status==2">(امکان ثبت کد دستگاه نمی باشد)</p>
                  <input type="text" class="EnglishClm" style="width: 70px;"
                    *ngIf="!OnSubmitForm_Finish && item.status!=2" [(ngModel)]="item.device_code">
                </td>
                <td>
                  <p class="EnglishClm" *ngIf="item.status==2">(امکان ثبت سریال دستگاه نمی باشد)</p>
                  <p class="EnglishClm" *ngIf="OnSubmitForm_Finish  && item.status!=2">{{item.device_serial}}</p>
                  <input type="text" class="EnglishClm" style="width: 70px;"
                    *ngIf="!OnSubmitForm_Finish  && item.status!=2" [(ngModel)]="item.device_serial">
                </td>
                <td>
                  <p class="EnglishClm" *ngIf="OnSubmitForm_Finish">{{item.dsc}}</p>
                  <input class="EnglishClm" type="text" *ngIf="!OnSubmitForm_Finish" [(ngModel)]="item.dsc">
                </td>
                <td>
                  <p *ngIf="item.status==1" style="color: #489b39;">دستگاه انجام شد، گواهی‌نامه صادر گردد.</p>
                  <p *ngIf="item.status==2" style="color: #9b7439;">دستگاه به درخواست مشتری از لیست انجام حذف و در
                    فاکتور مشتری لحاظ نمی‌شود.</p>
                  <p *ngIf="item.status==3" style="color: #9b3939;">با تایید مشتری کالیبراسیون دستگاه انجام شد ولی به
                    دلیل نقص، گواهی‌نامه مردود دستگاه صادر می‌شود.</p>

                </td>
                <td>
                  <p class="EnglishClm" *ngIf="OnSubmitForm_Finish && item.status==3">{{item.expert_off}}</p>
                  <input class="EnglishClm" style="width: 70px;" type="number"
                    *ngIf="!OnSubmitForm_Finish && item.status==3" [(ngModel)]="item.expert_off">
                </td>
                <td>{{item.persianDate}}</td>
                <td *ngIf="!OnSubmitForm_Finish">
                  <button type="button" *ngIf="item.status==1" (click)="openModal_DeviceBefa(templateDeviceBefa,item)"
                    class="btn btn-danger">
                    <i class="fa  fa-building"></i>
                    <span>
                      تجهیز بهفا
                    </span>
                  </button>
                  <br />
                  <span *ngIf="item.deviceBehfa.length>0">({{item.deviceBehfa.length}} مورد انتخاب شده)</span>
                </td>
                <td *ngIf="!OnSubmitForm_Finish">
                  <div class="btn-group  " role="group" aria-label="دکمه group with nested dropdown">
                    <div class="btn-group" role="group">
                      <button id="btnGroupDrop1" type="button" class="btn btn-warning dropdown-toggle"
                        data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                        امکانات
                      </button>
                      <div class="dropdown-menu" aria-labelledby="btnGroupDrop1">

                        <a style="cursor: pointer;" *ngIf="item.status!=1"
                          (click)="Change_Calibration_Detail_State(item,1)" class="dropdown-item"><i
                            class="fa fa-info"></i> حالت اول </a>
                        <a style="cursor: pointer;" *ngIf="item.status!=2"
                          (click)="Change_Calibration_Detail_State(item,2)" class="dropdown-item"><i
                            class="fa fa-warning"></i> حالت دوم </a>
                        <a style="cursor: pointer;" *ngIf="item.status!=3"
                          (click)="Change_Calibration_Detail_State(item,3)" class="dropdown-item"><i
                            class="fa fa-times-rectangle"></i> حالت سوم </a>

                        <a style="cursor: pointer;"
                          (click)="Delete_List_Calibration(Data_List_Calibration.indexOf(item))"
                          class="dropdown-item"><i class="fa fa-remove"></i> حذف </a>


                        <a style="cursor: pointer;" *ngIf="item.showDeviceBehfa && item.deviceBehfa.length>0"
                          (click)="Change_Calibration_Show(item)" class="dropdown-item"><i
                            class="fa fa fa-eye-slash"></i> عدم مشاهده </a>
                        <a style="cursor: pointer;" *ngIf="!item.showDeviceBehfa && item.deviceBehfa.length>0"
                          (click)="Change_Calibration_Show(item)" class="dropdown-item"><i class="fa fa-eye"></i>
                          مشاهده </a>

                      </div>
                    </div>
                  </div>
                </td>
              </tr>

              <tr *ngIf="item.deviceBehfa.length>0 && item.showDeviceBehfa">
                <td colspan="11">
                  <table class="mb-0 table table-bordered table-3 text-center table-striped">
                    <thead style="background-color: #9b7239; color: white;">
                      <tr>
                        <th>#</th>
                        <th>Description</th>
                        <th>Manufacturer</th>
                        <th>Model</th>
                        <th>Code BEHFA</th>
                        <th *ngIf="!OnSubmitForm_Finish">امکانات</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr *ngFor="let itemDevice of item.deviceBehfa">
                        <td>{{item.deviceBehfa.indexOf(itemDevice)+1}}</td>
                        <td>{{itemDevice.description}}</td>
                        <td>{{itemDevice.manufacturer}}</td>
                        <td>{{itemDevice.model}}</td>
                        <td>{{itemDevice.codeBEHFA}}</td>
                        <td *ngIf="!OnSubmitForm_Finish">
                          <button type="button"
                            (click)="Delete_List_DeviceBehfa(item.deviceBehfa.indexOf(itemDevice),item)"
                            class="btn btn-warning" style="margin-left: 5px;"> حذف <i class="fa fa-remove"></i>
                          </button>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </td>
              </tr>

            </ng-container>

            <tr>
              <td style="background: white;border: 0px;"></td>
            </tr>
            <tr>
              <td style="background: white;border: 0px;"></td>
            </tr>
            <tr>
              <td style="background: white;border: 0px;"></td>
            </tr>


          </tbody>
        </table>
      </div>


      <br />
      <hr />
      <br />

      <div style="display:none;">

        <div class="row" style="display: none;">
          <div class="form-group col-md-12">
            <label for="exampleInputEmail1"> عنوان آزمایشگاه </label>
            <input type="text" [(ngModel)]="LabCustomerAddress" class="form-control" placeholder="اینجا تایپ کنید ...">
          </div>
        </div>



        <h5> فایل/های ضمیمه </h5>


        <div class="row">
          <div class="form-group col-md-6">
            <label for="exampleInputEmail1">
              انتخاب فایل
              <button (click)="Remove_uploadImage1()" type="button" *ngIf="UploadImageSrc" class="btn  btn-danger"><i
                  class="fa  fa-times-rectangle"></i> </button>
            </label>
            <img *ngIf="InProccessing_Image1" src="assets/Loading.gif" style="width: 25px;" />
            <input *ngIf="!InProccessing_Image1" #file_Image1 (change)="uploadImage1(file_Image1.files)" type="file"
              class="form-control" placeholder="اینجا تایپ کنید ...">
          </div>
          <div class="form-group col-md-6">
            <label for="exampleInputEmail1">شرح</label>
            <input [(ngModel)]="UploadImageDSc" name="UploadImageDSc" type="text" class="form-control"
              placeholder="اینجا تایپ کنید ...">
          </div>
        </div>

        <button type="button" (click)="Add_uploadImage1()" [disabled]="!UploadImageSrc || !UploadImageDSc"
          class="btn btn-info" style="margin-left: 5px;"><i class="fa  fa-plus-circle"></i> افزودن ضمیمه </button>

        <br />


        <div class="table-responsive" *ngIf="UploadImageSrc_List.length>0">
          <table class="mb-0 table table-bordered table-3 text-center table-striped">
            <thead style="background-color: #489b39; color: white;">
              <tr>
                <th>#</th>
                <th>فایل</th>
                <th>شرح</th>

                <th>امکانات</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let item of UploadImageSrc_List">

                <td>{{UploadImageSrc_List.indexOf(item)+1}}</td>
                <td>

                  <a target="_blank" *ngIf="item.title.includes('.pdf')"
                    href="{{BaseUrl}}File/Calibration/{{item.title}}" class="btn btn-success"><i
                      class="fa fa-file-pdf-o"></i> PDF </a>


                  <img *ngIf="!item.title.includes('.pdf')" (click)="openModalImageZoom(templateImage,item.title)"
                    style="width: 150px;height: 150px;cursor: zoom-in;"
                    src="{{BaseUrl}}File/Calibration/{{item.title}}" />
                </td>
                <textarea type="text" class="form-control" [(ngModel)]="item.code"></textarea>
                <td>
                  <div class="btn-group  " role="group" aria-label="دکمه group with nested dropdown">
                    <div class="btn-group" role="group">
                      <button id="btnGroupDrop1" type="button" class="btn btn-warning dropdown-toggle"
                        data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                        امکانات
                      </button>
                      <div class="dropdown-menu" aria-labelledby="btnGroupDrop1">
                        <a style="cursor: pointer;"
                          (click)="UploadImageSrc_List_Delete(UploadImageSrc_List.indexOf(item))"
                          class="dropdown-item"><i class="fa fa-remove"></i> حذف </a>
                      </div>
                    </div>
                  </div>
                </td>

              </tr>
            </tbody>
          </table>
        </div>


        <br />
        <hr />
        <br />

        <div>

          <h5> ملاحظات </h5>

          <br />

          <form>

            <div class="row">
              <div class="form-group col-md-12">
                <label for="exampleInputEmail1"> متن ملاحظه : </label>
                <input [(ngModel)]="FormAdded_Dsc_Input" name="FormAdded_Dsc_Input" type="text" class="form-control"
                  placeholder="اینجا تایپ کنید ...">
              </div>
            </div>

            <button type="button" (click)="FormAdded_Dsc_Submit()" class="btn btn-success" style="margin-left: 5px;"><i
                class="fa  fa-plus-circle"></i> افزودن ملاحظه </button>

          </form>




          <br />
          <br />

          <div class="table-responsive" *ngIf="FormAdded_Dsc.length>0">


            <table class="mb-0 table table-bordered table-3 text-center table-striped">
              <thead style="background-color: #489b39; color: white;">
                <tr>
                  <th>#</th>
                  <th>پیام نامه</th>
                  <th>امکانات</th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let item of FormAdded_Dsc">
                  <td>{{FormAdded_Dsc.indexOf(item)+1}}</td>
                  <td>{{item}}</td>
                  <td style="cursor: pointer;">
                    <a style="cursor: pointer;" (click)="FormAdded_Dsc_Delete(FormAdded_Dsc.indexOf(item))"
                      class="dropdown-item"><i class="fa fa-remove"></i> حذف </a>
                  </td>
                </tr>
              </tbody>
            </table>




          </div>

          <br />
          <br />

        </div>

        <br />
        <br />

      </div>

    </div>



    <br />
    <br />
    <br />


    <button *ngIf="Data_Seleted_Customer.id>0 && !Proccesing_SubmitForm && !OnSubmitForm_Finish && IsMissionSupervisor"
      (click)="openModal_FinishForm(templateFinishForm)" type="button" class="btn btn-info" style="margin-left: 5px;"><i
        class="fa  fa-plus"></i> تایید و اتمام کار </button>
    <button *ngIf="Data_Seleted_Customer.id>0 && !Proccesing_SubmitForm && !OnSubmitForm_Finish"
      (click)="OnSubmitForm(0,templateCode)" type="button" class="btn btn-success" style="margin-left: 5px;"><i
        class="fa  fa-plus"></i> ذخیره اطلاعات </button>
    <button *ngIf="Proccesing_SubmitForm" type="button" class="btn btn-info" style="margin-left: 5px;"> لطفا صبر نمائید
      ... <i class="fa fa-spin fa-spinner"></i> </button>


    <button *ngIf="Calibration_Form_Id > 0 && IsMissionSupervisor" (click)="Open_Public_Device_List()" type="button" class="btn btn-primary" style="margin-left: 5px;">
      <i class="fa fa-eye"></i>
      مشاهده لیست دستگاه‌ها
    </button>

    <button (click)="OnSet_Back_CalibrationList(1)" type="button" class="btn btn-warning"><i
        class="fa fa-mail-reply"></i>
      بازگشت </button>


  </div>
</div>


<ng-template #templateCustomer>
  <div class="modal-header">
    <h4 class="modal-title pull-left">لیست اطلاعات مشتری </h4>
    <button type="button" class="close pull-right" aria-label="Close" (click)="modalRef_Customer.hide()">
      <span aria-hidden="true">×</span>
    </button>
  </div>
  <div class="modal-body">
    <div class="card-body">
      <div class="row">
        <div class="form-group col-md-12">
          <label for="exampleInputEmail1">نام مشتری </label>
          <input type="text" class="form-control" (keyup)="ReadData_Customer_KeySearch()"
            [(ngModel)]="Search_CodeName_Customer_Table" placeholder="برای جستجو اینجا تایپ کنید ...">
        </div>
      </div>

      <div class="table-responsive">
        <table class="mb-0 table table-bordered table-3 text-center table-striped">
          <thead style="background-color: #489b39; color: white;">
            <tr>
              <th>#</th>
              <th>کد مشتری بهفا</th>
              <th>نام مشتری</th>
              <th>امکانات</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let item of DataList_Customer
            | paginate
                    : {
                        id: 'DataList_Customer',
                        itemsPerPage: 10,
                        currentPage: page,
                        totalItems: (DataList_Customer).length
                      }">
              <td>{{DataList_Customer.indexOf(item)+1}}</td>
              <td>{{item.code}}</td>
              <td>{{item.name}}</td>
              <td (click)="Set_Selected_Customer_Record(item)" style="cursor: pointer;">
                <button class="btn btn-info"><i class="fa fa-check"></i> انتخاب</button>
              </td>

            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
  <div class="modal-footer">
    <img *ngIf="ProcssingCustomer" src="assets/Loading.gif" style="width: 25px;" />
    <button *ngIf="!ProcssingCustomer" type="button" (click)="ReadData_Customer()" class="btn btn-info"
      style="margin-left: 5px;"><i class="fa  fa-search"></i> جستجوی اطلاعات </button>
    <button type="button" class="btn btn-danger" (click)="modalRef_Customer.hide()">بستن</button>
  </div>
</ng-template>

<ng-template #templateDevice>
  <div class="modal-header">
    <h4 class="modal-title pull-left">لیست اطلاعات دستگاه های حکم '{{Selected_DataList_LetterRequestCustomer.id}}'
    </h4>

    <button type="button" class="close pull-right" aria-label="Close" (click)="modalRef_Device.hide()">
      <span aria-hidden="true">×</span>
    </button>
  </div>
  <div class="modal-body">
    <div class="card-body">
      <div class="row">
        <div class="form-group col-md-6">
          <input type="checkbox" [(ngModel)]="copyLastRecord_DeviceBehfa_For_Device"
            [checked]="copyLastRecord_DeviceBehfa_For_Device" /> کپی تجهیزات ردیف آخر
        </div>

      </div>

      <div class="table-responsive">
        <table class="mb-0 table table-bordered table-3 text-center table-striped">
          <thead style="background-color: #489b39; color: white;">
            <tr>
              <th>#</th>
              <th>دستگاه لاتین</th>
              <th>دستگاه فارسی</th>
              <th>سریال دستگاه</th>
              <th>کد دستگاه</th>


              <th>توضیحات</th>
              <th>امکانات</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let item of DataList_Device_Filtered">
              <td>{{DataList_Device_Filtered.indexOf(item)+1}}</td>
              <td class="EnglishClm">{{item.device_name_en}}</td>
              <td>{{item.device_name}}</td>
              <td>{{item.deviceSerial}}</td>
              <td>{{item.deviceCode}}</td>

              <td>{{item.deviceCustomerDsc}}</td>

              <td (click)="Set_Selected_Device_Record(item)" style="cursor: pointer;">
                <button class="btn btn-info"><i class="fa fa-check"></i> انتخاب</button>
              </td>

            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
  <div class="modal-footer">

    <img *ngIf="ProcssingDevice" src="assets/Loading.gif" style="width: 25px;" />
    <button *ngIf="!ProcssingDevice" type="button" (click)="ReadData_Device()" class="btn btn-info"
      style="margin-left: 5px;"><i class="fa  fa-search"></i> جستجوی اطلاعات </button>
    <button type="button" class="btn btn-danger" (click)="modalRef_Device.hide()">بستن</button>
  </div>
</ng-template>

<ng-template #templateDeviceBefa>
  <div class="modal-header">
    <h4 class="modal-title pull-left">لیست اطلاعات دستگاه بهفا </h4>
    <button type="button" class="close pull-right" aria-label="Close" (click)="modalRef_DeviceBefa.hide()">
      <span aria-hidden="true">×</span>
    </button>
  </div>
  <div class="modal-body">
    <div class="card-body">
      <div class="row">
        <div class="form-group col-md-4">
          <label for="exampleInputEmail1"> Code BEHFA </label>
          <input type="text" class="form-control" [(ngModel)]="Filter_Behfa_codeBEHFA"
            placeholder="برای جستجو اینجا تایپ کنید ...">
        </div>
        <div class="form-group col-md-4">
          <label for="exampleInputEmail1"> Description </label>
          <input type="text" class="form-control" [(ngModel)]="Filter_Behfa_description"
            placeholder="برای جستجو اینجا تایپ کنید ...">
        </div>
        <div class="form-group col-md-4">
          <label for="exampleInputEmail1"> Manufacturer </label>
          <input type="text" class="form-control" [(ngModel)]="Filter_Behfa_manufacturer"
            placeholder="برای جستجو اینجا تایپ کنید ...">
        </div>
      </div>

      <div class="table-responsive">
        <table class="mb-0 table table-bordered table-3 text-center table-striped">
          <thead style="background-color: #489b39; color: white;">
            <tr>
              <th>#</th>
              <th style="cursor: pointer;" (click)="ChangeOrder_DeviceBefa('groupTitle')">
                <i *ngIf="order_DeviceBefa=='groupTitle' && !orderreverse" class="fa fa-sort-down"></i>
                <i *ngIf="order_DeviceBefa=='groupTitle' && orderreverse" class="fa fa-sort-up"></i>
                Group
              </th>
              <th style="cursor: pointer;" (click)="ChangeOrder_DeviceBefa('description')">
                <i *ngIf="order_DeviceBefa=='description' && !orderreverse" class="fa fa-sort-down"></i>
                <i *ngIf="order_DeviceBefa=='description' && orderreverse" class="fa fa-sort-up"></i>
                Description
              </th>
              <th style="cursor: pointer;" (click)="ChangeOrder_DeviceBefa('manufacturer')">
                <i *ngIf="order_DeviceBefa=='manufacturer' && !orderreverse" class="fa fa-sort-down"></i>
                <i *ngIf="order_DeviceBefa=='manufacturer' && orderreverse" class="fa fa-sort-up"></i>
                Manufacturer
              </th>
              <th style="cursor: pointer;" (click)="ChangeOrder_DeviceBefa('model')">
                <i *ngIf="order_DeviceBefa=='model' && !orderreverse" class="fa fa-sort-down"></i>
                <i *ngIf="order_DeviceBefa=='model' && orderreverse" class="fa fa-sort-up"></i>
                Model
              </th>
              <th style="cursor: pointer;" (click)="ChangeOrder_DeviceBefa('codeBEHFA')">
                <i *ngIf="order_DeviceBefa=='codeBEHFA' && !orderreverse" class="fa fa-sort-down"></i>
                <i *ngIf="order_DeviceBefa=='codeBEHFA' && orderreverse" class="fa fa-sort-up"></i>
                Code BEHFA
              </th>
              <th style="cursor: pointer;" (click)="ChangeOrder_DeviceBefa('certificateNo')">
                <i *ngIf="order_DeviceBefa=='certificateNo' && !orderreverse" class="fa fa-sort-down"></i>
                <i *ngIf="order_DeviceBefa=='certificateNo' && orderreverse" class="fa fa-sort-up"></i>
                Certificate No.
              </th>
              <th style="cursor: pointer;" (click)="ChangeOrder_DeviceBefa('calDue')">
                <i *ngIf="order_DeviceBefa=='calDue' && !orderreverse" class="fa fa-sort-down"></i>
                <i *ngIf="order_DeviceBefa=='calDue' && orderreverse" class="fa fa-sort-up"></i>
                Cal. Due
              </th>
              <th>امکانات</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let item of DataList_DeviceBehfa
            | orderBy: order_DeviceBefa : orderreverse_DeviceBefa
            |filter:Filter_Behfa_description:'description'
            |filter:Filter_Behfa_manufacturer:'manufacturer'
            |filter:Filter_Behfa_codeBEHFA:'codeBEHFA'">
              <td>{{DataList_DeviceBehfa.indexOf(item)+1}}</td>
              <td>{{item.groupTitle}}</td>
              <td class="EnglishClm">{{item.description}}</td>
              <td class="EnglishClm">{{item.manufacturer}}</td>
              <td class="EnglishClm">{{item.model}}</td>
              <td class="EnglishClm">{{item.codeBEHFA}}</td>
              <td class="EnglishClm">{{item.certificateNo}}</td>
              <td class="EnglishClm">{{item.calDue}}</td>
              <td (click)="Set_Selected_DeviceBefa_Record(item)" style="cursor: pointer;">
                <button class="btn btn-info"><i class="fa fa-check"></i> انتخاب</button>
              </td>

            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
  <div class="modal-footer">
    <img *ngIf="Procssing_DeviceBehfa" src="assets/Loading.gif" style="width: 25px;" />
    <button *ngIf="!Procssing_DeviceBehfa" type="button" (click)="ReadData_DeviceBehfa()" class="btn btn-info"
      style="margin-left: 5px;"><i class="fa  fa-search"></i> جستجوی اطلاعات </button>
    <button type="button" class="btn btn-danger" (click)="modalRef_DeviceBefa.hide()">بستن</button>
  </div>
</ng-template>

<ng-template #templateShowMANUFACTURE>
  <div class="modal-header">
    <h4 class="modal-title pull-left">لیست اطلاعات سازنده و مدل دستگاه
      {{Data_List_Calibration[Selected_MANUFACTURE_Calibration_Indexer].device_name}} </h4>
    <button type="button" class="close pull-right" aria-label="Close" (click)="modalRef_ShowManufaccure.hide()">
      <span aria-hidden="true">×</span>
    </button>
  </div>
  <div class="modal-body">
    <div class="card-body">
      <div class="row">
        <div class="form-group col-md-12">
          <label for="exampleInputEmail1"> MANUFACTURE </label>
          <input type="text" class="form-control" [(ngModel)]="Filter_MANUFACTURE"
            placeholder="برای جستجو اینجا تایپ کنید ...">
        </div>
      </div>

      <div class="table-responsive">
        <table class="mb-0 table table-bordered table-3 text-center table-striped">
          <thead style="background-color: #489b39; color: white;">
            <tr>
              <th>#</th>
              <th>MANUFACTURE</th>
              <th>MODEL</th>
            </tr>
          </thead>
          <tbody>
            <ng-container *ngFor="let item of Device_MANUFACTURE_List
            |filter:Filter_MANUFACTURE:'mANUFACTURE'
            | paginate
                    : {
                        id: 'Device_MANUFACTURE_ListId',
                        itemsPerPage: 10,
                        currentPage: page,
                        totalItems: (Device_MANUFACTURE_List|filter:Filter_MANUFACTURE:'mANUFACTURE').length
                      }">

              <tr>
                <td>{{Device_MANUFACTURE_List.indexOf(item)+1}}</td>
                <td>{{item.mANUFACTURE}}</td>
                <td>{{item.mODEL}}</td>
              </tr>
              <tr>
                <td colspan="3">
                  <table class="mb-0 table table-bordered table-3 text-center table-striped">
                    <thead style="background-color: #393b9b; color: white;">
                      <tr>
                        <th>#</th>
                        <th>RESOLUTION</th>
                        <th>واحد</th>
                        <th>RANGE</th>
                        <th>واحد</th>
                        <th>امکانات</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr *ngFor="let itemDetail of item.detail">
                        <td>{{item.detail.indexOf(itemDetail)+1}}</td>
                        <td>{{itemDetail.rESOLUTION}}</td>
                        <td>{{itemDetail.rESOLUTION_Vahed}}</td>
                        <td>
                          از {{itemDetail.rANGE_MIN}} تا {{itemDetail.rANGE_MAX}}
                        </td>
                        <td>{{itemDetail.rANGE_Vahed}}</td>
                        <td (click)="Set_Selected_MANUFACTURE_Record(item,itemDetail)" style="cursor: pointer;">
                          <button class="btn btn-info"><i class="fa fa-check"></i> انتخاب</button>
                        </td>
                      </tr>

                    </tbody>
                  </table>
                </td>
              </tr>

            </ng-container>
          </tbody>
        </table>
      </div>
    </div>
  </div>
  <div class="modal-footer">
    <img *ngIf="ProcssingMANUFACTURE" src="assets/Loading.gif" style="width: 25px;" />
    <button *ngIf="!ProcssingMANUFACTURE" type="button" (click)="ReadData_MANUFACTURE()" class="btn btn-info"
      style="margin-left: 5px;"><i class="fa  fa-search"></i> جستجوی اطلاعات </button>
    <button type="button" class="btn btn-danger" (click)="modalRef_ShowManufaccure.hide()">بستن</button>
  </div>
</ng-template>

<ng-template #templateCode>
  <div class="modal-header">
    <h4 class="modal-title pull-left"> شماره رسید </h4>
    <button type="button" class="close pull-right" aria-label="Close" (click)="modalRef_Code.hide()">
      <span aria-hidden="true">×</span>
    </button>
  </div>
  <div class="modal-body">
    <p>شماره رسید فرم کالبیراسیون در محل تجهیزات <b>'{{Calibration_Form_Code}}'</b></p>
  </div>
  <div class="modal-footer">

    <button type="button" class="btn btn-danger" (click)="modalRef_Code.hide()">بستن</button>
  </div>
</ng-template>

<ng-template #templateFinishForm>

  <div class="modal-header">
    <h4 class="modal-title pull-left">
      تایید ثبت نهایی اطلاعات
    </h4>

    <button type="button" class="close pull-right" aria-label="Close" (click)="modalRef_FinishForm.hide()">

      <span aria-hidden="true">×</span>
    </button>
  </div>


  <div class="modal-body">

    <!-- بخش اول : اطلاعات کارشناس مشتری -->
    <div class="card mb-3">

      <div class="card-header">
        <strong>اطلاعات کارشناس مشتری</strong>
      </div>

      <div class="card-body">

        <div class="row">

          <div class="form-group col-md-6">

            <label>
              نام کارشناس مشتری
            </label>

            <input type="text" class="form-control" [(ngModel)]="FinishCustomerExpertName"
              name="FinishCustomerExpertName" placeholder="نام کارشناس مشتری را وارد نمایید">

          </div>


          <div class="form-group col-md-6">

            <label>
              شماره همراه کارشناس مشتری
            </label>

            <input type="text" (ngModelChange)="ChangeFinishCustomerInfo()" class="form-control EnglishClm"
              [(ngModel)]="FinishCustomerExpertMobile" name="FinishCustomerExpertMobile" maxlength="11"
              placeholder="مثال: 0912123456789">

          </div>

        </div>


        <div class="row">

          <div class="form-group col-md-12">

            <label>
              نام مشتری
            </label>

            <input type="text" (ngModelChange)="ChangeFinishCustomerInfo()" class="form-control"
              [value]="Data_Seleted_Customer.name" disabled>

          </div>

        </div>

      </div>

    </div>



    <div class="card">

      <div class="card-header">
        <strong>تایید پیامکی کارشناس مشتری</strong>
      </div>

      <div class="card-body">

        <div class="row">

          <div class="form-group col-md-6">

            <button type="button" class="btn btn-success" [disabled]="FinishOtpProcessing"
              (click)="SendFinishConfirmCode()">

              <i *ngIf="!FinishOtpProcessing" class="fa fa-send">
              </i>

              <i *ngIf="FinishOtpProcessing" class="fa fa-spin fa-spinner">
              </i>

              ارسال کد تایید

            </button>

          </div>


          <div class="form-group col-md-6">

            <label>
              کد تایید
            </label>

            <input type="text" class="form-control EnglishClm" [(ngModel)]="FinishOtpCode" name="FinishOtpCode"
              maxlength="6" autocomplete="off" placeholder="کد تایید ارسال شده را وارد نمایید">

          </div>

        </div>


        <div *ngIf="FinishOtpSent && !FinishOtpVerified" class="alert alert-success">

          <i class="fa fa-check-circle"></i>

          کد تایید برای کارشناس مشتری ارسال شد.

        </div>


        <div *ngIf="FinishOtpVerified" class="alert alert-success">

          <i class="fa fa-check-circle"></i>

          کد تایید کارشناس مشتری با موفقیت تایید شد.

        </div>

      </div>

    </div>

  </div>


  <div class="modal-footer">

    <button *ngIf="
        Data_Seleted_Customer.id > 0 &&
        !Proccesing_SubmitForm &&
        !OnSubmitForm_Finish
      " [disabled]="!FinishOtpSent" (click)="OnSubmitForm(1,templateCode)" type="button" class="btn btn-info"
      style="margin-left: 5px;">

      <i class="fa fa-check"></i>

      تایید و اتمام کار

    </button>


    <button type="button" class="btn btn-danger" (click)="modalRef_FinishForm.hide()">

      بستن

    </button>

  </div>

</ng-template>

<ng-template #templateLetterRequestCustomer>
  <div class="modal-header">
    <h4 class="modal-title pull-left">لیست اطلاعات نامه های سیستم </h4>
    <button type="button" class="close pull-right" aria-label="Close" (click)="modalRef_LetterRequestCustomer.hide()">
      <span aria-hidden="true">×</span>
    </button>
  </div>
  <div class="modal-body">
    <div class="card-body">
      <div class="row">
        <div class="form-group col-md-12">
          <label for="exampleInputEmail1"> شماره نامه </label>
          <input type="text" class="form-control" [(ngModel)]="Search_code_LetterRequestCustomer"
            placeholder="برای جستجو اینجا تایپ کنید ...">
        </div>
        <div class="form-group col-md-12">
          <label for="exampleInputEmail1"> موضوع نامه </label>
          <input type="text" class="form-control" [(ngModel)]="Search_persianDate_LetterRequestCustomer"
            placeholder="برای جستجو اینجا تایپ کنید ...">
        </div>
        <div class="form-group col-md-12">
          <label for="exampleInputEmail1">نام مشتری </label>
          <input type="text" class="form-control" [(ngModel)]="Search_customer_LetterRequestCustomer"
            placeholder="برای جستجو اینجا تایپ کنید ...">
        </div>
      </div>

      <div class="table-responsive">
        <table class="mb-0 table table-bordered table-3 text-center table-striped">
          <thead style="background-color: #489b39; color: white;">
            <tr>
              <th>#</th>
              <th>شماره نامه</th>
              <th>نوع نامه</th>
              <th>نام مشتری</th>
              <th>موضوع نامه </th>
              <th>نام گیرنده</th>
              <th>سمت گیرنده</th>
              <th>کاربر فرستنده</th>
              <th>کاربر گیرنده</th>
              <th>وضیعت</th>
              <th>پیام</th>
              <th>امکانات</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let item of DataList_LetterRequestCustomer
            |filter:Search_persianDate_LetterRequestCustomer:'subject_name'
            |filter:Search_customer_LetterRequestCustomer:'customer'
            |filter:Search_code_LetterRequestCustomer:'code'
            | paginate
                    : {
                        id: 'DataList_FeildTable',
                        itemsPerPage: 10,
                        currentPage: page,
                        totalItems: (DataList_LetterRequestCustomer
                        |filter:Search_persianDate_LetterRequestCustomer:'subject_name'
                        |filter:Search_code_LetterRequestCustomer:'code'
                        |filter:Search_customer_LetterRequestCustomer:'customer').length
                      }
            ">
              <td>{{DataList_LetterRequestCustomer.indexOf(item)+1}}</td>
              <td>{{item.code}}</td>
              <td>{{item.letterType}}</td>
              <td>{{item.customer}}</td>
              <td>{{item.subject_name}}</td>
              <td>{{item.giver_name}}</td>
              <td>{{item.giver_semat}}</td>
              <td>{{item.lastSender}}</td>
              <td>{{item.lastGiver}}</td>
              <td>{{item.lastSection}}</td>
              <td>{{item.lastOrder}}</td>
              <td (click)="Set_Selected_LetterRequestCustomer(item)" style="cursor: pointer;">
                <button class="btn btn-info"><i class="fa fa-check"></i> انتخاب</button>
              </td>

            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
  <div class="modal-footer">
    <img *ngIf="ProcssingCustomer" src="assets/Loading.gif" style="width: 25px;" />
    <button *ngIf="!Procssing_LetterRequestCustomer" type="button" (click)="ReadData_LetterRequestCustomer()"
      class="btn btn-info" style="margin-left: 5px;"><i class="fa  fa-search"></i> جستجوی اطلاعات </button>
    <button type="button" class="btn btn-danger" (click)="modalRef_LetterRequestCustomer.hide()">بستن</button>
  </div>
</ng-template>


<ng-template #templateDraftClibration>
  <div class="modal-header">
    <h4 class="modal-title pull-left"> بایگانی شماره نامه '{{Selected_DataList_LetterRequestCustomerDraft.code}}' </h4>
    <button type="button" class="close pull-right" aria-label="Close"
      (click)="modalRef_DraftClibrationReception.hide()">
      <span aria-hidden="true">×</span>
    </button>
  </div>
  <div class="modal-body">
    <div class="row">
      <div class="form-group col-md-12">
        <label for="exampleInputEmail1">توضیحات</label>
        <input type="text" class="form-control" name="DraftClibrationReceptionDsc"
          [(ngModel)]="DraftClibrationReceptionDsc" placeholder="اینجا تایپ کنید ...">
      </div>
    </div>
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-success" (click)="ChangeDraftClibrationReceptionModal()"> ارسال و ثبت </button>
    <button type="button" class="btn btn-danger" (click)="modalRef_DraftClibrationReception.hide()">بستن</button>
  </div>
</ng-template>


<ng-template #templateLetterRequestCustomerCancel>
  <div class="modal-header">
    <h4 class="modal-title pull-left">تایید لغو ماموریت با شماره حکم
      <b>{{Selected_DataList_LetterRequestCustomer_Canecl.code2}} </b>
    </h4>
    <button type="button" class="close pull-right" aria-label="Close" (click)="modalRef_Cancel.hide()">
      <span aria-hidden="true">×</span>
    </button>
  </div>
  <div class="card-body">
    <div class="row">

      <div class="form-group col-md-12">
        <label for="exampleInputEmail1"> توضیحات </label>
        <input [(ngModel)]="Selected_Filter_Dsc" name="Selected_Filter_Dsc" type="text" class="form-control "
          placeholder="اینجا تایپ کنید ...">
      </div>

    </div>

  </div>
  <div class="modal-footer">
    <button type="button" [disabled]="!Selected_Filter_Dsc" class="btn btn-warning"
      (click)="LetterCustomer_Cancel(Data_Seleted_Cancel)"> لغو ماموریت <i class="fa fa-times-circle"></i></button>

    <button type="button" class="btn btn-danger" (click)="modalRef_Cancel.hide()">بستن</button>
  </div>
</ng-template>


<ng-template #templateMissionDevices>
  <div class="modal-header">
    <h4 class="modal-title pull-left">لیست دستگاه‌های مأموریت</h4>
    <button type="button" class="close pull-right" aria-label="بستن" (click)="modalRef_MissionDevices.hide()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body" dir="rtl">
    <p *ngIf="MissionDeviceReviewLoading" role="status">در حال دریافت لیست دستگاه‌ها...</p>
    <p *ngIf="MissionDeviceReviewError" class="text-danger" role="alert">{{MissionDeviceReviewError}}</p>
    <div class="table-responsive" *ngIf="!MissionDeviceReviewLoading && !MissionDeviceReviewError">
      <table class="table table-bordered table-striped">
        <thead style="background-color: #489b39; color: white;">
          <tr >
            <th>ردیف</th><th>شماره رسید</th><th>نام دستگاه</th><th>کد دستگاه</th><th>سریال دستگاه</th>
            <th>وضعیت</th><th>توضیحات</th><th>درصد تخفیف</th><th>تاریخ ثبت</th><th>ثبت‌کننده</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let item of MissionDeviceReview; let i = index">
            <td>{{i + 1}}</td>
            <td>{{item.calibrationCode || item.calibrationId}}</td>
            <td>{{item.deviceName || '-'}}</td>
            <td class="EnglishClm">{{item.deviceCode || '-'}}</td>
            <td class="EnglishClm">{{item.serial || '-'}}</td>
            <td [ngSwitch]="item.status">
              <span *ngSwitchCase="1">دستگاه انجام شد / صدور گواهی</span>
              <span *ngSwitchCase="2">حذف به درخواست مشتری / عدم لحاظ در فاکتور</span>
              <span *ngSwitchCase="3">انجام شده ولی گواهی مردود</span>
              <span *ngSwitchDefault>-</span>
            </td>
            <td style="white-space: pre-wrap;">{{item.description || '-'}}</td>
            <td>{{item.discountPercent != null ? item.discountPercent + '%' : '-'}}</td>
            <td>{{item.registeredDatePersian || '-'}}</td>
            <td>
              <div>{{item.createdByName || '-'}}</div>
              <div class="EnglishClm" *ngIf="item.createdByUsername">({{item.createdByUsername}})</div>
            </td>
          </tr>
          <tr *ngIf="MissionDeviceReview.length === 0"><td colspan="10">دستگاهی برای این مأموریت ثبت نشده است.</td></tr>
        </tbody>
      </table>
    </div>
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-danger" (click)="modalRef_MissionDevices.hide()">بستن</button>
  </div>
</ng-template>

<ng-template #templateImage>
  <div class="modal-header">
    <h4 class="modal-title pull-left"> نمایش عکس </h4>
    <button type="button" class="close pull-right" aria-label="Close" (click)="modalRef_Image.hide()">
      <span aria-hidden="true">×</span>
    </button>
  </div>
  <div class="modal-body" style="text-align: center;">
    <img style="max-width: 350px;" src="{{BaseUrl}}File/Calibration/{{ModalimageUrl}}" />
  </div>
  <div class="modal-footer">
    <a class="dropdown-item" target="_blank" href="{{BaseUrl}}File/Calibration/{{ModalimageUrl}}"><i
        class="fa fa-download"></i> دانلود </a>
    <button type="button" class="btn btn-danger" (click)="modalRef_Image.hide()">بستن</button>
  </div>
</ng-template>
